// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"3a179b29","107":"f78af3f2","378":"25b8fadf","665":"4e35ce92","968":"e458fc88"}[chunkId] + ".css";
};